import axios from "axios";
import { apiEndpoint } from "@iso/lib/helpers/endpoint";
import { authHeader } from "@iso/lib/helpers/authHeader";

export const weatherEmailSettingService = {
  getByPropertyId,
  create,
  getRecipients,
  updateRecipients,
  getPropertyUsers,
};

function getByPropertyId(propertyId) {
  return axios
    .get(`${apiEndpoint.weatherEmailSetting}/get-by-property-id?property_id=${propertyId}`, {
      headers: authHeader(),
    })
    .then((res) => {
      if (res && res.status === 200) {
        return res.data;
      }
      return [];
    });
}

function create(data) {
  return axios
    .post(apiEndpoint.weatherEmailSetting, data, {
      headers: authHeader(),
    })
    .then((res) => {
      if (res && res.status === 200) {
        return res.data;
      }
      return {};
    });
}

function getRecipients(propertyId) {
  return axios
    .get(`${apiEndpoint.weatherEmailSetting}/get-recipients?property_id=${propertyId}`, {
      headers: authHeader(),
    })
    .then((res) => {
      if (res && res.status === 200) {
        return res.data;
      }
      return {};
    })
    .catch((err) => {
      console.error('Failed to get recipients:', err);
      return {};
    });
}

function updateRecipients(data) {
  return axios
    .post(`${apiEndpoint.weatherEmailSetting}/update-recipients`, data, {
      headers: authHeader(),
    })
    .then((res) => {
      if (res && res.status === 200) {
        return res.data;
      }
      return {};
    })
    .catch((err) => {
      console.error('Failed to update recipients:', err);
      return {};
    });
}

function getPropertyUsers(propertyId) {
  return axios
    .get(`${apiEndpoint.weatherEmailSetting}/get-property-users?property_id=${propertyId}`, {
      headers: authHeader(),
    })
    .then((res) => {
      if (res && res.status === 200) {
        return res.data;
      }
      return {};
    })
    .catch((err) => {
      console.error('Failed to get property users:', err);
      return {};
    });
}
